export enum ModalTypes {
  jobShareModal = 'jobShareModal',
  aiAssistantModal = 'aiAssistantModal'
} 